import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';
import ControlViewModelBuilder from '@/Builder/ControlViewModelBuilder';
import ComponentManager from '@/Management/ComponentManager';
import { IImageViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';

export default class ImageViewModelBuilder<T = null> extends ControlViewModelBuilder<ImageViewModelT, T> {

    protected properties: IImageViewModelConstructorParameter;
    protected alternativeTextBuilder: LabelViewModelBuilder<this>;

    public constructor(parent?: T) {
        super(parent);
    }

    public withSource(source: ObservableOrDefault<string>): this {
        this.properties.source = source;
        return this;
    }

    public withAlternativeText(): LabelViewModelBuilder<this> {
        if (this.alternativeTextBuilder == null)
            this.alternativeTextBuilder = new LabelViewModelBuilder<this>(this);

        return this.alternativeTextBuilder;
    }

    public withAlternativeTextErgName(ergName: ObservableOrDefault<string>): this {
        return this.withAlternativeText().withErgName(ergName).done();
    }

    public withWidth(width: number | string): this {
        this.properties.width = width;
        return this;
    }

    public withHeight(height: number | string): this {
        this.properties.height = height;
        return this;
    }

    public withIsToolBarLink(isToolBarLink: boolean): this {
        this.properties.isToolBarLink = isToolBarLink;
        return this;
    }

    public withTooltipHtmlEnabled(tooltipHtmlEnabled: boolean): this {
        this.properties.tooltipHtmlEnabled = tooltipHtmlEnabled;
        return this;
    }

    public withIsBinary(isBinary: boolean): this {
        this.properties.isBinary = isBinary;
        return this;
    }

    public withSvgSource(svgSource: ObservableOrDefault<string>): this {
        this.properties.svgSource = svgSource;
        return this;
    }

    public updateProperties(properties: Partial<IImageViewModelConstructorParameter>): this {
        $.extend(this.properties, properties);
        return this;
    }

    /**
     * @override
     * @inheritdoc 
     */
    protected buildInternal(): ImageViewModelT {
        const ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');

        if (this.alternativeTextBuilder != null)
            this.properties.alternativeText = this.alternativeTextBuilder.build();

        return new ImageViewModel(this.properties);
    }
}